import { ItemModel } from "../../../infrastructure/model/ProductItemModel";
import { ITEM_CATEGORY_NAME_ENUM, ITEM_TYPE_ENUM } from "../../constants/AppConst";
import { HOME_PAGE_SECTION_NAME_ENUM } from "../../constants/AppData";
export const HOME_CATEGORY_CONFIG = [
  {
    key: HOME_PAGE_SECTION_NAME_ENUM.COFFEE_MATCHA_HOT_DRINK,
    label: ITEM_CATEGORY_NAME_ENUM.COFFEE_MATCHA_HOT_DRINK,
    types: [ITEM_TYPE_ENUM.COFFEE_MATCHA_HOT_DRINK],
    className: "section_coffee",
  },
  {
    key: HOME_PAGE_SECTION_NAME_ENUM.OOLONG_MILK_TEA_SECTION,
    label: ITEM_CATEGORY_NAME_ENUM.OOLONG_MILK_TEA,
    types: [ITEM_TYPE_ENUM.OOLONG_MILK_TEA],
    className: "section_o_long",
  },
  {
    key: HOME_PAGE_SECTION_NAME_ENUM.BLACK_MILK_TEA_SECTION,
    label: ITEM_CATEGORY_NAME_ENUM.BLACK_MILK_TEA,
    types: [ITEM_TYPE_ENUM.BLACK_MILK_TEA],
    className: "section_hong_tra",
  },
  {
    key: HOME_PAGE_SECTION_NAME_ENUM.FRESH_FRUIT_JUICE_SECTION,
    label: ITEM_CATEGORY_NAME_ENUM.FRESH_FRUIT_JUICE,
    types: [ITEM_TYPE_ENUM.FRESH_FRUIT_JUICE],
    className: "section_tra_hoa_qua",
  },
  {
    key: HOME_PAGE_SECTION_NAME_ENUM.NON_CAFFEIN_SECTION,
    label: ITEM_CATEGORY_NAME_ENUM.NON_CAFFEIN,
    types: [ITEM_TYPE_ENUM.NON_CAFFEIN],
    className: "section_sua_chua",
  },
  {
    key: HOME_PAGE_SECTION_NAME_ENUM.SMOOTHIE_SECTION,
    label: ITEM_CATEGORY_NAME_ENUM.SMOOTHIE,
    types: [ITEM_TYPE_ENUM.SMOOTHIE],
    className: "section_da_xay_sinh_to",
  },
  {
    key: HOME_PAGE_SECTION_NAME_ENUM.SEASON_DRINKS_SECTION,
    label: ITEM_CATEGORY_NAME_ENUM.SEASON_DRINKS,
    types: [ITEM_TYPE_ENUM.SEASON_DRINKS],
    className: "section_season",
  },
];

export function getHomePageSectionMenu(activeItems: ItemModel[]) {
  return HOME_CATEGORY_CONFIG.map((c, index) => ({
    id: index,
    key: c.key,
    label: c.label,
    className: c.className,
    data: activeItems?.filter((item) => c.types.includes(item.type)),
  }));
}

export function getSaleScreenSectionMenu(activeItems: ItemModel[]) {
  return [
    {
      id: 9,
      key: "9",
      label: ITEM_CATEGORY_NAME_ENUM.SEASON_DRINKS,
      data: activeItems?.filter((t) => t.type === ITEM_TYPE_ENUM.SEASON_DRINKS),
      className: "section_season",
    },
    ...getHomePageSectionMenu(activeItems).slice(0, 6),
    {
      id: 7,
      key: "7",
      label: ITEM_CATEGORY_NAME_ENUM.OTHER,
      data: activeItems?.filter((t) => t.type === ITEM_TYPE_ENUM.OTHER),
      className: "section_khac",
    },
    {
      id: 8,
      key: "8",
      label: ITEM_CATEGORY_NAME_ENUM.TOPPING,
      data: activeItems?.filter((t) => t.type === ITEM_TYPE_ENUM.TOPPING),
      className: "section_topping",
    },
  ];
}
